// contains translations for the tour component

export const TOUR_TRANSLATIONS = {
  'en-US': {
    application_card:
      'Each card shows an application you’ve created, including its type, status stage, address, and date.',

    application_card_deatils:
      'Select “View Details” to open the full application page where you can see more information and track its progress.',

    create_application_button: 'Click here to create a new application.',

    pre_lodgement_button: 'Click here to begin your pre-lodgement process.',

    final_lodgement_button: 'Click here to lodge a new application for assessment.',

    pagination_next_button: 'Go to the next page of applications.',

    pagination_prev_button: 'Go to the previous page of applications.',

    language_dropdown: 'Change the language of the application interface.',

    // mapView translations
    slider_toggle: 'Expand or collapse the side panel.',

    map_control: 'Use these controls to switch between different map layers.',

    legend_control: 'View the legend that explains the map overlays.',

    add_overlay: 'Add or remove overlays on the map.',

    draw_control: 'Draw architectural plans directly on the map.',

    import_plan_control: 'Import your architectural plans onto the map.',

    screenshot_button: 'Capture a screenshot of the current map view with all active overlays.',

    capture_screenshot_button:
      'Automatically capture screenshots of all active overlays to help you better understand the site and generate reports.',

    // upload document page
    upload_section:
      'This section lists all documents required for the application. Please gather and upload each necessary file before proceeding.',
  },
  'hi-IN': {},
  'zh-CN': {},
};
